import moment from "moment";
export class JobAds {
  JobAdCode;
  CompCode;
  CompName;
  JobCode;
  JobPosition;
  DateFrom;
  DateTo;
  JobAdContent;
  Rem;
  Interviewer;
  UserName;
  Closed;
  RecDel;
  Seq;
  tempCode;
  IsEditMode;
  IsFromMenuActive;
  IsToMenuActive;
  IsNewAdded;
  JobEDesc;
  constructor() {
    this.JobAdCode = "";
    this.CompCode = "";
    this.CompName = "";
    this.JobCode = "";
    this.JobPosition = "";
    this.DateFrom = moment().format("YYYY-MM-DD");
    this.DateTo = moment().format("YYYY-MM-DD");
    this.JobAdContent = "";
    this.Rem = "";
    this.Interviewer = "";
    this.UserName = "";
    this.Closed = false;
    this.RecDel = false;
    this.Seq = "";
    this.tempCode = "";
    this.IsEditMode = false;
    this.IsFromMenuActive = false;
    this.IsToMenuActive = false;
    this.IsNewAdded = false;
    this.JobEDesc = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/JobAds.js